import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import { CheckboxGif } from 'assets/images';
import './styles.less';
import {
  termsOfUseBadesc,
  termsOfUseBadescWoman,
  termsOfUseBadescGeneral,
  termsOfUseBadescInovacao,
  AllTermsOfUseBadesul,
} from 'utils';
import { Button, Modal } from 'components/sdk';

const AllTermsOfUseBadesc = {
  'Pronampe Emergencial CP': termsOfUseBadesc,
  'Pronampe Emergencial SE': termsOfUseBadesc,
  'Pronampe Mulher': termsOfUseBadescWoman,
  'Pronampe Geral': termsOfUseBadescGeneral,
  'Pronampe Inovação': termsOfUseBadescInovacao,
  'Pronampe Inovação BNDES': termsOfUseBadescInovacao,
};

const TermsAndPoliciesOptIn = ({
  setConfirmation,
  overwriteType,
  portfolioName,
  showDefaultTerms,
}) => {
  const [normalConfirmation, setNormalConfirmation] = useState(false);
  const [overwriteConfirmation, setOverwriteConfirmation] = useState(false);

  const [termsModal, setTermsModal] = useState(null);
  const [termsVisible, setTermsVisible] = useState(false);

  // Conteúdo e visibilidade separados: zerar os dois juntos apagaria o texto DURANTE a
  // animação de fechamento do modal (o usuário veria a caixa esvaziar antes de sumir).
  const openTermsModal = (title, content) => {
    setTermsModal({ title, content });
    setTermsVisible(true);
  };

  const badesulTerms = AllTermsOfUseBadesul[portfolioName];

  useEffect(() => {
    const defaultConfirmed = !showDefaultTerms || normalConfirmation;

    setConfirmation(overwriteType ? overwriteConfirmation && defaultConfirmed : defaultConfirmed);
  }, [normalConfirmation, overwriteConfirmation, showDefaultTerms, overwriteType]);

  return (
    <div className="opt-in-content gyra-custom-scroll">
      <img src={CheckboxGif} alt="Checkbox Gif" />

      {showDefaultTerms && (
        <Checkbox
          checked={normalConfirmation}
          id="opt-in-checkbox"
          onChange={({ target: { checked } }) => setNormalConfirmation(checked)}
        >
          <p>
            Li e aceito os{' '}
            <a
              className="secondary-text"
              href="https://faq.gyramais.com.br/termos-de-uso/"
              target="_blank"
              rel="noreferrer"
            >
              Termos e Condições do Solicitante
            </a>{' '}
            e da{' '}
            <a
              className="secondary-text"
              href="https://faq.gyramais.com.br/termos-de-consulta-registradoras/"
              target="_blank"
              rel="noreferrer"
            >
              Registradora
            </a>{' '}
            e as{' '}
            <a
              className="secondary-text"
              href="https://faq.gyramais.com.br/politica-de-privacidade/"
              target="_blank"
              rel="noreferrer"
            >
              Políticas de Privacidade.
            </a>
          </p>
        </Checkbox>
      )}

      {overwriteType === 'BADESC' && (
        <Checkbox
          checked={overwriteConfirmation}
          id="opt-in-badesc-checkbox"
          onChange={({ target: { checked } }) => setOverwriteConfirmation(checked)}
        >
          <p>
            Li e aceito os{' '}
            <Button
              text
              className="badesc-modal-button secondary-text"
              onClick={() => {
                openTermsModal('Termos de uso', AllTermsOfUseBadesc[portfolioName]);
              }}
            >
              Termos do Badesc
            </Button>
          </p>
        </Checkbox>
      )}

      {overwriteType === 'BADESUL' && (
        <Checkbox
          checked={overwriteConfirmation}
          id="opt-in-badesul-checkbox"
          onChange={({ target: { checked } }) => setOverwriteConfirmation(checked)}
        >
          <p>
            Li e estou ciente das regras da{' '}
            <Button
              text
              className="badesc-modal-button secondary-text"
              onClick={() => {
                // Carteiras Badesul sem termo escrito seguem no FAQ, como antes.
                if (!badesulTerms) {
                  window.open(
                    'https://faq.gyramais.com.br/badesul/',
                    '_blank',
                    'noopener,noreferrer',
                  );
                  return;
                }

                openTermsModal(`Termo de Ciência — Linha ${portfolioName}`, badesulTerms);
              }}
            >
              linha BADESUL
            </Button>
          </p>
        </Checkbox>
      )}

      <Modal
        title={termsModal?.title}
        visible={termsVisible}
        onCancel={() => setTermsVisible(false)}
        afterClose={() => setTermsModal(null)}
        footer={<Button onClick={() => setTermsVisible(false)}>Fechar</Button>}
      >
        {/* container de scroll do termo: focável para leitura só por teclado (WCAG 2.1.1) */}
        <div
          className="badesc-terms-container"
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex={0}
          role="region"
          aria-label="Texto do termo"
        >
          {termsModal?.content}
        </div>
      </Modal>
    </div>
  );
};

TermsAndPoliciesOptIn.propTypes = {
  setConfirmation: PropTypes.func.isRequired,
  overwriteType: PropTypes.string,
  portfolioName: PropTypes.string,
  showDefaultTerms: PropTypes.bool,
};

TermsAndPoliciesOptIn.defaultProps = {
  overwriteType: undefined,
  portfolioName: undefined,
  showDefaultTerms: true,
};

export default memo(TermsAndPoliciesOptIn);
